import PropTypes from "prop-types";
import { MaintenancePage } from "../pages/MaintenancePage";
import { DashboardLayout } from "./dashboard";
import { AuthGuardWithAuth0 } from "@/guards/AuthGuardWithAuth0";

// Add maintenance mode check
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === "true";

const MaintenanceGuard = ({ children }) => {
  // Optional: Add logic to check if current user/IP is allowed to bypass maintenance mode
  const shouldBypassMaintenance = () => {
    return false;
  };

  if (MAINTENANCE_MODE && !shouldBypassMaintenance()) {
    return <MaintenancePage />;
  }

  return children;
};

export const DefaultLayout = ({ children }) => {
  return (
    <MaintenanceGuard>
      <AuthGuardWithAuth0>
        <DashboardLayout>{children}</DashboardLayout>
      </AuthGuardWithAuth0>
    </MaintenanceGuard>
  );
};

export const DefaultUnauthenticatedLayout = ({ children }) => {
  return (
    <MaintenanceGuard>
      <DashboardLayout>{children}</DashboardLayout>
    </MaintenanceGuard>
  );
};

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

MaintenanceGuard.propTypes = {
  children: PropTypes.node.isRequired,
};
